/**
 * The lowercase letters `abcdefghijklmnopqrstuvwxyz`.
 *
 * @category String
 */
export var asciiLowercase = 'abcdefghijklmnopqrstuvwxyz';
/**
 * The uppercase letters `ABCDEFGHIJKLMNOPQRSTUVWXYZ`.
 *
 * @category String
 */
export var asciiUppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
/**
 * The concatenation of the [[asciiLowercase]] and [[asciiUppercase]] constants.
 *
 * @category String
 */
export var asciiLetters = asciiLowercase + asciiUppercase;
/**
 * The string `0123456789`.
 *
 * @category String
 */
export var digits = '0123456789';
/**
 * The string `0123456789abcdefABCDEF`.
 *
 * @category String
 */
export var hexdigits = '0123456789abcdefABCDEF';
/**
 * The string `01234567`.
 *
 * @category String
 */
export var octdigits = '01234567';
/**
 * String of ASCII characters which are considered punctuation characters in the C locale:
 * `!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~.`
 *
 * @category String
 */
export var punctuation = '!"#$%&\'()*+,-./:;<=>?@[]^_`{|}~';
/**
 * Truncates string
 *
 * @example
 * ```
 * truncate('Hello world', 8)
 * // Hello...
 * ```
 * @category String
 */
export function truncate(value, length, ending) {
    if (ending === void 0) { ending = '...'; }
    if (value.length > length) {
        return value.substring(0, length - ending.length) + ending;
    }
    else {
        return value;
    }
}
/**
 * Extract words from text.
 *
 * @example
 * ```
 * extractWords('Hello-world!')
 * // ['Hello', 'world']
 * ```
 * @category String
 */
export function extractWords(value) {
    return value
        .split(/[ -./\\()"',;<>~!@#$%^&*|+=[\]{}`~?:]+/)
        .filter(function (v) { return v !== ''; });
}
/**
 * Convert a dash/dot/underscore/space separated string to camelCase
 *
 * @example
 * ```
 * camelCase('foo-bar');
 * // 'fooBar'
 * ```
 * @category String
 */
export function camelCase(value) {
    return value
        .replace(/^[_.\- ]+/, '')
        .toLowerCase()
        .replace(/[_.\- ]+(\w|$)/g, function (_, p1) { return p1.toUpperCase(); })
        .replace(/\d+(\w|$)/g, function (m) { return m.toUpperCase(); });
}
/**
 * Convert a dash/dot/underscore/space separated string to PascalCase
 *
 * @example
 * ```
 * pascalCase('foo-bar');
 * // 'FooBar'
 * ```
 * @category String
 */
export function pascalCase(value) {
    var parsed = camelCase(value);
    return parsed.charAt(0).toUpperCase() + parsed.slice(1);
}
